import { COURSE_ADMIN_ASSIGN_ROLES, INSTRUCTOR_ROLES } from "../../utils/roles";

/**
 * Sidebar actions on /GestionCursos: role or delegated course permissions.
 */

export function showInstructorGestionarCursoButton(rol, roleLoaded) {
  return roleLoaded === true && typeof rol === "string" && INSTRUCTOR_ROLES.includes(rol);
}

export function showConfigurarTestsButton(rol, roleLoaded, puedeModificar = false) {
  if (!roleLoaded) {
    return false;
  }
  if (puedeModificar === true) {
    return true;
  }
  return typeof rol === "string" && COURSE_ADMIN_ASSIGN_ROLES.includes(rol);
}
